import SVG from "react-inlinesvg";
import NavLink from "../../Navlink";
import styles from "./leftSidebar.module.scss";
// //import Link from "next/link";
import siteInfo from "@/constants/siteInfo";
import sendGAEvent from "@/utils/gaEvent";
// import { useRouter } from "next/router";

// components/Sidebar.js
export default function Sidebar({
  header_menu = [],
  setClickedMenuIndex = null,
  clickedMenuIndex = null,
  isRajasthan = false, isMadhya = false,
  isHR = false, isUP = false, isBH = false, isUK = false, isCGH = false
}) {
  return (
    <aside
      className={`${styles.sidebar} hidden md:flex flex-col overflow-scroll h-full py-1 border-r-[1px] border-gray-200`}
    >

      {header_menu?.map((item, index) => (
        <div key={index}>
          <NavLink
            exact={true}
            role="button"
            id={item?.id}
            title={item?.title}
            href={`${item?.canonical_url ?? "/"}`}
            onMouseLeave={() => {
              if (!item.sub_menu || item?.sub_menu?.length === 0) {
                setClickedMenuIndex(null);
              }
            }}
            onMouseEnter={() => {
              if (item?.sub_menu?.length === 0) {
                setClickedMenuIndex(null);
              } else if (item?.sub_menu?.length > 0) {
                setClickedMenuIndex(index);
              }
            }}
            onClick={() => {
              let eventName = `Category List Click - ${item?.title} Tab`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
            activeclassname=" bg-primary-300 !text-primary border-l-4 border-l-primary"
            className={`flex items-center justify-between px-4 py-2 text-slate-600 ${isRajasthan ? 'hover:bg-rajasthanLight hover:text-rajasthanDark' : isMadhya ? 'hover:bg-mpLight hover:text-mpDark' : isHR ? 'hover:bg-hrLight hover:text-hrDark' : isBH ? 'hover:bg-biharLight hover:text-biharDark' : isUP ? 'hover:bg-upLight hover:text-upDark' : isUK ? "hover:bg-ukLight hover:text-ukDark" : isCGH ? 'hover:bg-mpLight hover:text-mpDark' : 'hover:bg-primary-300 hover:text-primary'}`}
          >
            <div className="flex items-center">
              {item?.svg && (
                <div className="w-4 h-4">
                  <SVG className="w-4 h-4" src={item?.svg} />
                </div>
              )}
              <span
                id={"dropdownHoverButton_" + index}
                data-dropdown-toggle={"dropdownHover_" + index}
                className="mx-2 font-medium"
              >
                {item?.title}
              </span>
            </div>
            {item?.sub_menu?.length > 0 && (
              <button
                onMouseEnter={() => {
                  setClickedMenuIndex(index);
                }}
                onMouseLeave={() => {
                  if (clickedMenuIndex !== index) {
                    setClickedMenuIndex(null);
                  }
                }}
                className="ml-2 flex items-center justify-center" // Adjust for proper spacing and alignment
                aria-label="Open submenu"
              >
                <SVG
                  className="w-[0.6rem] h-[0.6rem]"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrow2.svg"
                />
                {/* Invisible clickable area around the arrow */}
                <span className="w-8 h-8 absolute"></span>
              </button>
            )}
          </NavLink>
        </div>
      ))}

      {/* Spacer div to push social links to the bottom */}
      <div className="flex-grow"></div>

      <div className="flex items-start justify-start gap-2 px-2 py-4">
        <a
          href={siteInfo.socialLinks.twitter}
          target="_blank"
          className={`w-8 h-8 ${isRajasthan ? 'text-rajasthanDark' : isMadhya ? 'text-mpDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isUK ? "text-ukDark" : isCGH ? 'text-mpDark' : 'text-primary'}`}
        >
           <svg
            width="101"
            height="100"
            viewBox="0 0 101 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8"
          >
            <path
              opacity="0.1"
              d="M98.2221 50C98.2221 76.3869 76.8313 97.7778 50.4443 97.7778C24.0574 97.7778 2.66656 76.3869 2.66656 50C2.66656 23.6131 24.0574 2.22222 50.4443 2.22222C76.8313 2.22222 98.2221 23.6131 98.2221 50Z"
              stroke="currentColor"
              strokeWidth="4.44444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.7773 35.5556H47.5551L53.9579 45.5556L62.8885 35.5556H68.2218L56.4162 48.8889L69.3329 66.6667H56.6662L49.3329 56.6667L39.5551 66.6667H33.7773L45.9996 53.3334L33.7773 35.5556ZM58.2218 63.3334L40.9996 38.8889H44.8885L62.6662 63.3334H58.2218Z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          href={siteInfo.socialLinks.facebook}
          target="_blank"
          className={`w-8 h-8 ${isRajasthan ? 'text-rajasthanDark' : isMadhya ? 'text-mpDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isUK ? 'text-ukDark' : isCGH ? 'text-mpDark' : 'text-primary'}`}
        >
<svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" alt="Facebook" loading="lazy"><g id="Facebook"><g id="facebook"><path id="Oval Copy" opacity="0.1" d="M43.7012 23.0615C43.7012 34.9494 34.2071 44.5615 22.5259 44.5615C10.8448 44.5615 1.35059 34.9494 1.35059 23.0615C1.35059 11.1736 10.8448 1.56152 22.5259 1.56152C34.2071 1.56152 43.7012 11.1736 43.7012 23.0615Z" stroke="currentColor" strokeWidth="2"></path><path id="Shape" d="M20.7529 29.9545L20.7327 23.6576H18.0928V20.9589H20.7327V19.1598C20.7327 16.7317 22.2036 15.5615 24.3224 15.5615C25.3374 15.5615 26.2097 15.6388 26.4639 15.6733V18.2108L24.9944 18.2115C23.842 18.2115 23.6189 18.7713 23.6189 19.5927V20.9589H26.8925L26.0125 23.6576H23.6189V29.9545H20.7529Z" fill="currentColor"></path></g></g></svg>

        </a>
        <a
          href={siteInfo.socialLinks.instagram}
          target="_blank"
          className={`w-8 h-8 ${isRajasthan ? 'text-rajasthanDark' : isMadhya ? 'text-mpDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isUK ? "text-ukDark" : isCGH ? 'text-mpDark' : 'text-primary'}`}
        >
                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" alt="instagram" loading="lazy"><g id="Instagram"><g id="insta"><path id="Oval Copy" opacity="0.1" d="M44.0518 23.0615C44.0518 34.9494 34.5577 44.5615 22.8765 44.5615C11.1953 44.5615 1.70117 34.9494 1.70117 23.0615C1.70117 11.1736 11.1953 1.56152 22.8765 1.56152C34.5577 1.56152 44.0518 11.1736 44.0518 23.0615Z" stroke="currentColor" strokeWidth="2"></path><g id="16px-logo-instagram"><path id="Oval" d="M26.1926 20.5024C26.6171 20.5024 26.9613 20.1532 26.9613 19.7224C26.9613 19.2916 26.6171 18.9424 26.1926 18.9424C25.768 18.9424 25.4238 19.2916 25.4238 19.7224C25.4238 20.1532 25.768 20.5024 26.1926 20.5024Z" fill="currentColor"></path><path id="Shape" fillRule="evenodd" clipRule="evenodd" d="M19.6738 23.0615C19.6738 24.8539 21.1104 26.3115 22.8769 26.3115C24.6434 26.3115 26.08 24.8539 26.08 23.0615C26.08 21.2691 24.6434 19.8115 22.8769 19.8115C21.1104 19.8115 19.6738 21.2691 19.6738 23.0615ZM21.2754 23.0615C21.2754 22.1653 21.9937 21.4365 22.8769 21.4365C23.7602 21.4365 24.4785 22.1653 24.4785 23.0615C24.4785 23.9577 23.7602 24.6865 22.8769 24.6865C21.9937 24.6865 21.2754 23.9577 21.2754 23.0615Z" fill="currentColor"></path><path id="Shape_2" fillRule="evenodd" clipRule="evenodd" d="M19.6738 29.5615H26.08C27.7264 29.5615 29.2831 27.982 29.2831 26.3115V19.8115C29.2831 18.141 27.7264 16.5615 26.08 16.5615H19.6738C18.0274 16.5615 16.4707 18.141 16.4707 19.8115V26.3115C16.4707 27.982 18.0274 29.5615 19.6738 29.5615ZM18.0723 19.8115C18.0723 19.0518 18.9251 18.1865 19.6738 18.1865H26.08C26.8287 18.1865 27.6816 19.0518 27.6816 19.8115V26.3115C27.6816 27.0712 26.8287 27.9365 26.08 27.9365H19.6738C18.9107 27.9365 18.0723 27.0858 18.0723 26.3115V19.8115Z" fill="currentColor"></path></g></g></g></svg>

        </a>
        <a
          href={siteInfo.socialLinks.youtube}
          target="_blank"
          className={`w-8 h-8 ${isRajasthan ? 'text-rajasthanDark' : isMadhya ? 'text-mpDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isUK ? "text-ukDark" : isCGH ? 'text-mpDark' : 'text-primary'}`}
        >
          <SVG
            className="w-8 h-8"
            alt="youtube"
            loading="lazy"
            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/youtube.svg"
          />
        </a>
      </div>
    </aside>
  );
}
